import type {ApprovalPart, AssistantContentPart} from "@/types/chatMessages";

export function isApprovalPart(part: AssistantContentPart): part is ApprovalPart {
   return part.type === "functionCall" && part.data.approval != null;
}

/** Only the latest reply's approvals can be decided; continuations map back to their proposal. */
export function isApprovalActive(part: ApprovalPart, {messageId, approvalMessageIds, activeMessageId}: {
   messageId?: string;
   approvalMessageIds?: Record<string, string>;
   activeMessageId?: string;
}): boolean {
   return !!messageId && (approvalMessageIds?.[part.data.approval.id] ?? messageId) === activeMessageId;
}

type ContentGroup =
   | {approval: true; parts: ApprovalPart[]; start: number}
   | {approval: false; parts: AssistantContentPart[]; start: number};

/** Assistant approvals group separately from ordinary content; proposals always stand alone and order is preserved. */
export function groupApprovalParts(parts: AssistantContentPart[], isUser: boolean): ContentGroup[] {
   const groups: ContentGroup[] = [];
   parts.forEach((part, index) => {
      const previousGroup = groups.at(-1);
      const previousPart = previousGroup?.parts.at(-1);
      const hasProposal = isApprovalPart(part) && part.data.approval.proposal != null;
      const previousHasProposal = previousPart != null && isApprovalPart(previousPart) && previousPart.data.approval.proposal != null;

      if (hasProposal || previousHasProposal) {
         groups.push(!isUser && isApprovalPart(part)
            ? {approval: true, parts: [part], start: index}
            : {approval: false, parts: [part], start: index});
         return;
      }

      if (!isUser && isApprovalPart(part)) {
         if (previousGroup?.approval) {
            previousGroup.parts.push(part);
         } else groups.push({approval: true, parts: [part], start: index});
      } else if (previousGroup && !previousGroup.approval) {
         previousGroup.parts.push(part);
      } else groups.push({approval: false, parts: [part], start: index});
   });
   return groups;
}
